/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import i18next from 'i18next'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import {getParentAll, getIcon, getPricelistBJBImportV2, exportData} from '../../../../../api/modules/master-data/master_2'
import Pagination from '../../../component/Pagination'
import swal from 'sweetalert'
import {getAccessesMenu} from '../../../../../api/modules/access/access'
import {Col, Row, Spinner} from 'react-bootstrap'
import {RowFilter} from './RowFilter'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {fetchJbps, fetchMenus, headers} from '../../../../../services/fetcher'
import {objToParams} from '../../../../../utils/objToParams'
import {
  filterSelector,
  resetFilterMasterJBP,
  setFilterMasterJBP,
  setIsFetchData,
} from '../../../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../../../hooks/useRowTable'
import * as TableUI from '../../../../../components/Table/Table'
import {StyledCard} from '../../../../../components/StyledCard'
import {StyledButtonGroups} from '../../../../../components/StyledButtonGroups'
import {HakAkses} from '../../../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {SkeletonForm} from 'src/components/Skeletons'
import {ActionIcon} from 'src/components'
import {useLoaderList} from 'src/hooks/useLoaderList'
import { useSalesOrganization } from 'src/hooks/useSalesOrganization'
import { useRegions } from 'src/hooks/useRegions'
import { useCities } from 'src/hooks/useCities'
import { useNavigate } from 'react-router'
import dateformat from 'src/utils/dateformat'
import Select from 'react-select'
import { InputFile } from 'src/app/components/InputFile'

const Table = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterMasterJBP: filterMenu} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 12,
    onReloadTable: () => handleResetTable(),
  })

  const {
    isLoadingEditButton,
    onInitializeLoaderList,
    onUpdateLoaderListByIndex,
    onResetLoaderList,
  } = useLoaderList()

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [datas, setDatas] = useState([])
  const [parent, setParent] = useState(null)
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [accesses, setAccesses] = useState(null)
  const [icon, setIcon] = useState(null)
  const [isError, setIsError] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filterMenu?.per_page ?? 5
    return page * per - per
  }, [filterMenu, page])

  useEffect(() => {
    const getParent = async () => {
      setLoading(true)
      const res = await getParentAll()
      const data = res.data.data
      setParent(data)
      setPage(data.current_page)
      setPer(data.per_page)
      setLoading(false)
    }

    const getAccess = async () => {
      setLoading(true)
      const res = await getAccessesMenu(roleId)
      setAccesses(res.data.data)
    }

    const getIconList = async () => {
      setLoading(true)
      const res = await getIcon()
      setIcon(res.data.data)
    }

    getIconList()
    getAccess()
    getParent()
    // getMenu()
  }, [])

  const paginateNumber = async (url) => {
    try {
      setLoading(true)
      setIsError(false)

      const token = localStorage.getItem('token')
      const endpoint = `${url}&${objToParams({
        ...filterMenu,
        credentials: localStorage.getItem('credential')
    })}`
      const res = await axios.get(endpoint, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
          'X-Credentials': localStorage.getItem('credential')
        },
      })

      setDatas(res.data.data.data)
      setPage(res.data.data.current_page)
      setNumberURL(res.data.data.links)
      onInitializeLoaderList(res.data.data.data)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }
  
  const [isUpload, setIsUpload] = useState(false)


  const deleteMenu = async (id) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          axios
            .delete(`${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2}/price-list/jbp-config/delete/${id}?credentials=${localStorage.getItem('credential')}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((response) => {
              setIsUpload(true)
              swal({
                title: `${t('JBP Berhasil di Hapus')}`,
                icon: 'success',
              })
                .then(() => {
                  setActived(!actived)
                  onFetchMenus()
                })
                .catch((error) => {})
            })
        }
      })
      .catch((error) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const [showSkeletonModal, setShowSkeletonModal] = useState(false)

  const handleEdit = async (id) => {
    sessionStorage.setItem('jbp-id', id)
    sessionStorage.setItem('jbp', 'jbp')
    navigate('/master/jbp/edit/' + id)
  }

  //#region state for search
  const [actived, setActived] = useState(false)

  const onFetchMenus = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchJbps(filterMenu)
      .then((res) => {
        setDatas(res.data.data.data)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
        onInitializeLoaderList(res.data.data.data)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterMenu])

  useEffect(() => {
    const getData = setTimeout(onFetchMenus, 1000)
    return () => clearTimeout(getData)
  }, [onFetchMenus])
  //#endregion

  const handlePageSizeChange = (value) => {
    dispatch(setFilterMasterJBP({...filterMenu, per_page: value ?? 5}))
  }

  const handleResetTable = () => {
    dispatch(resetFilterMasterJBP())
  }

  const [files, setFiles] = useState({file: null})
  const [showUpload, setShowUpload] = useState(false)
  const [showExport, setShowExport] = useState(false)
  const [detail, setDetail] = useState([])
  const [regionDetail, setRegionDetail] = useState(false)
  const [cityDetail, setCityDetail] = useState(false)
  const [ieAction, setIEAction] = useState(null)
  const [loadingExport, setLoadingExport] = useState(false)

  const navigate = useNavigate()

  const handleAddPrice = async () => {
    sessionStorage.setItem('jbp', 'jbp')
    navigate('/master/jbp/create')
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    const lang = i18next.language
    let file = files.file
    let formdata = new FormData()
    formdata.append('file', file)
    const credential = localStorage.getItem('credential')
    await getPricelistBJBImportV2(lang, formdata, credential)
      .then(
        (res) => {
          swal({
            title: res.data.message,
            icon: 'success',
            buttons: [`${t('Ok')}`, `${t('see-log')}`],
          }).then((show) => {
            setShowUpload(false)
            setActived(!actived)
            
            if(show){
              navigate('/log/queue')
            }
          })
        },
        (err) => {
          swal({
            title: t(err.response.data.message),
            icon: 'error',
          })
        }
      )
      .catch((err) => {
        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleCheckFile = (url) => {
    axios
      .get(url)
      .then((response) => {
        window.open(url)
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const downloadTemplate = (cond) => {
    if (cond === 'region')
      handleCheckFile(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/regions/export?token=${localStorage.getItem('token')}`
      )
    else if (cond === 'sales')
      handleCheckFile(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/sales-org/export?credentials=${localStorage.getItem(
          'credential'
        )}&token=${localStorage.getItem('token')}`
      )
    else if (cond === 'list')
      handleCheckFile(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2
        }/price-list/jbp-config/download-template?credentials=${localStorage.getItem(
          'credential'
        )}&token=${localStorage.getItem('token')}`
      )
  }

  const handleDetail = async (items, type) => {
    if(type == 'region'){
      setRegionDetail(true)
    }
    if(type == 'city'){
      const _provinces = items[0]
      const _provincesWithCities = _provinces.map((_prov) => {
        return {
          id: _prov.id,
          name: _prov.region_name,
          cities: items[1].filter((_city) => _city.region_id == _prov.id).map((_city) => {
            return {
              id: _city.id,
              name: _city.city_name,
            }
          })
        }
      })

      setDetail(_provincesWithCities)
      setCityDetail(true)
      return
    }

    setDetail(items)
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-jbp-pricing-filter'))
      return persisted
    }catch(e){ return null }
  }

  const handleResetFilter = () => {
    dispatch(resetFilterMasterJBP())
  }

  const handleExportData = async () => {
    if(loadingExport) return
    try {
      setLoadingExport(true)

      const response = await exportData(filterMenu);

      const href = URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `jbp-pricing.xlsx`)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingExport(false)
    } catch (error) {
      setLoadingExport(false)
      swal({
        title: t('Export Failed'),
        icon: 'error',
      })
    }
  }

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <>
            <SelectPageSize
              initialValue={filterMenu?.per_page ?? 5}
              onChange={(value: any) => handlePageSizeChange(value?.value)}
            />

            { hasFilter() && <button type="button" onClick={() => handleResetFilter()} className="btn btn-outline-danger btn-sm">Clear Filter</button> }
          </>
        }
        rightContent={
          <>
            { loadingExport && (
              <span className='loading-text text-primary'>Exporting...</span>
            )}
            <Select
              styles={{
                container: (base: any) => ({...base, padding: '0 !important', maxWidth: 160, minWidth: 150}),
                menuPortal: (base: any) => ({...base, zIndex: 1000}),
                control: (base: any) => ({
                  ...base,
                  color: 'black',
                  borderWidth: 2,
                  borderRadius: 6,
                  borderColor: '#d9dce4',
                  textAlign: 'left',
                  maxWidth: 160,
                }),
              }}
              options={[
                {
                  value: 'export',
                  label: 'Export Data'
                },
                {
                  value: 'import',
                  label: 'Import Data'
                },
                {
                  value: 'template',
                  label: 'Download Template'
                },
              ]}
              onChange={(value) => {
                setIEAction(value?.value)
                switch(value?.value){
                  case 'export':
                    handleExportData()
                    break;
                  case 'import':
                    setShowUpload(true)
                    break;
                  case 'template':
                    setShowExport(true)
                    break;
                  default:
                    break;
                }
              }}
            />
            { hakAkses?.create && (
              <button onClick={() => {
                    handleAddPrice()
                }} className='btn btn-primary d-flex align-items-center'>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('order-tambah') + ' ' + t('jbp')}</p>
              </button>
            )}
          </>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('Code')}</th>
              {/* <th>{t('Sales Org Code')}</th> */}
              <th>{t('sub-order-produsen')}</th>
              <th>{t('jbp-type-code')}</th>
              <th>{t('jbp-type')}</th>
              <th>{t('Customer Code')}</th>
              <th>{t('Customer Name')}</th>
              <th>{t('sub-order-provinsi')}</th>
              <th>{t('sub-order-kota')}</th>
              <th>{t('valid date')}</th>
              <th>{t('valid to')}</th>
              <th>{t('order-aksi')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : datas?.length === 0 ? (
              <RowEmptyData />
            ) : (
              datas?.map((item, _index) => (
                <tr key={item?.code ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{item.code}</td>
                  {/* <td>{item.company_code}</td> */}
                  <td>{item.company?.name}</td>
                  <td>{item.jbp_type?.code}</td>
                  <td>{item.jbp_type?.type}</td>
                  <td>{item.customer_code}</td>
                  <td>{[
                    item.customer?.title,
                    item.customer?.name,
                  ].join(". ")}</td>
                  <td className='cursor-pointer' onClick={() => handleDetail(item?.provinces, 'region')}>
                    <span className='px-2 pb-2 border-bottom border-primary'>
                      { item?.provinces?.[0]?.region_name }
                    </span>
                  </td>
                  <td className='cursor-pointer' onClick={() => handleDetail([
                    item?.provinces,
                    item?.cities,
                  ], 'city')}>
                  <span className='px-2 pb-2 border-bottom border-primary'>
                    { item?.cities?.[0]?.city_name }
                    </span>
                  </td>
                  <td>{dateformat(item.valid_from)}</td>
                  <td>{dateformat(item.valid_to)}</td>
                  <td>
                    <div>
                      {hakAkses?.update && (
                        <ActionIcon
                          className='me-1'
                          iconPath='/media/icons/duotune/pencil-fill.svg'
                          title={t('ubah')}
                          isLoading={isLoadingEditButton(_index)}
                          disabled={isLoadingEditButton(_index)}
                          onClick={() => {
                            handleEdit(item.id)
                          }}
                        />
                      )}
                      {hakAkses?.delete && (
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          title={t('Hapus')}
                          onClick={() => deleteMenu(item.id)}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showExport}
        onHide={() => setShowExport(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Download Template')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-center'>
            <button
              className='btn btn-info me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('Download Template')}
              onClick={() => downloadTemplate('region')}
            >
              <KTSVG path='/media/icons/duotune/download.svg' />
              {t('Download Template')} {t('kontrak-wilayah')} & {t('sub-order-kota')}
            </button>
            <button
              className='btn btn-info me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('Download Template')}
              onClick={() => downloadTemplate('sales')}
            >
              <KTSVG path='/media/icons/duotune/download.svg' />
              {t('Download Template')} Sales Org
            </button>
            <button
              className='btn btn-info me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('Download Template')}
              onClick={() => downloadTemplate('list')}
            >
              <KTSVG path='/media/icons/duotune/download.svg' />
              {t('Download Template')} {t('jbp')}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showUpload}
        onHide={() => setShowUpload(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Import')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td style={{width: '120px'}}>
                <h6>{t('order-fileUnggah')}</h6>
              </td>
              <td className='w-75'>
                <InputFile
                    setFileName={(value) => {}}
                    setFiles={setFiles}
                    isBase64={false}
                />
              </td>
            </tr>
          </table>
          <div className='d-flex justify-content-end mt-5'>
            <Button
              variant='primary'
              className='w-100'
              onClick={() => handleUpload()}
              disabled={btnLoading}
            >
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-kirim')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={regionDetail}
        onHide={() => setRegionDetail(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Region Name')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-4'>
            {detail.map((data, _index) => (
              <>
                <Col md={4}>
                  <div className='mb-3'>
                    <span className='me-2'>•</span>
                    {data.region_name}
                  </div>
                </Col>
              </>
            ))}
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        show={cityDetail}
        onHide={() => setCityDetail(false)}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('City Name')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className='mb-4'>
            {detail.map((province) => (
              <>
                <Col md={12}>
                  <div className='mb-1 font-weight-bold h4'>
                    {province.name}
                  </div>
                  <hr/>

                  <Row className='mb-4'>
                    {province.cities?.map((city) => (
                      <>
                        <Col md={4}>
                          <div className='mb-1'>
                            <span className='me-2'>•</span>
                            {city.name}
                          </div>
                        </Col>
                      </>
                    ))}
                  </Row>
                </Col>
              </>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {Table}